import { render, staticRenderFns } from "./kyc-account-log-table.vue?vue&type=template&id=cdbf1636"
import script from "./kyc-account-log-table.vue?vue&type=script&lang=js"
export * from "./kyc-account-log-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports